const ProductDetails = ({ t }) => {
  const img = [
    { url: "/assets/productImg1.jpg" },
    { url: "/assets/productImg2.jpg" },
    { url: "/assets/productImg3.jpg" },
  ];
  return (
    <section>
      <div className="p-4 space-y-2 border bg-sideBar border-primary rounded-xl">
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("productName")}:</p>
            <p className="font-semibold">تيشيرت رياضي</p>
          </div>
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("category1")}:</p>
            <p className="font-semibold">ملابس</p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("price")}:</p>
            <p className="font-semibold">250 JD</p>
          </div>
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("quantity")}:</p>
            <p className="font-semibold">13</p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("status")}:</p>
            <p className="font-semibold">متاح</p>
          </div>
        </div>
      </div>
      <div>
        <h3 className="my-3 font-semibold text-primary">{t("productPics")}</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {img.map((img, i) => {
            return (
              <img
                className="border aspect-square border-dashed border-[#D1D5DB] rounded-lg"
                src={img.url}
                alt={i}
              />
            );
          })}
        </div>
      </div>
      <div>
        <h3 className="my-3 font-semibold text-primary">{t("shortDesc")}</h3>

        <div className="p-4 space-y-2 border bg-sideBar border-primary rounded-xl">
          تيشيرت قطن عالي الجودة مناسب للتدريب
        </div>
      </div>
    </section>
  );
};

export default ProductDetails;
